import { v1 as uuid } from 'uuid';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type NotificationType = 'warning' | 'successful' | 'error' | 'info';

export interface INotification {
  id: string;
  type: NotificationType;
  message: string;
  timeToHide?: number;
  autoClose?: boolean;
}

export type INotifications = Array<INotification>;

const initialState: INotifications = [];

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: initialState,
  reducers: {
    removeNotification: (state, action: PayloadAction<string>) => {
      state.splice(Number(action.payload), 1);
    },
    showNotification: (
      state,
      action: PayloadAction<Omit<INotification, 'id'>>
    ) => {
      const { autoClose = true, timeToHide = 3000 } = action.payload;

      const isNotificationDuplicate = state.some(
        (n) =>
          n.type === action.payload.type && n.message === action.payload.message
      );

      if (!isNotificationDuplicate) {
        state.push({ ...action.payload, id: uuid(), autoClose, timeToHide });
      }
    },
  },
});

export const { removeNotification, showNotification } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
